export default function getLeafsFromListThatLooksLikeTree (arr) {
  const parents = arr.map(r => r.parent_id)
  const res = arr.filter(r => !parents.includes(r.id))
  return res
}
